const FormResources = 
{
    form_data:
    {
        building_id: '',
        level_id: '',
        area_id: '',
        room_type_id: '',
        associate_id: [],
        employee_associate_id: [],
        score_simbol: 1,
        score: '',
        date_range: {},
        inspection_template_id: ''

    },

    simbol_options:[
        {
            id:     1,
            name:   '=',
        },
        {
            id:     2,
            name:   '<',
        },
        {
            id:     3,
            name:   '>',
        },
    ],

    form_format: [
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Building:',
            model_name: 'building_id',
            ref:        'building_id_input',
            ref_alt:    'building_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Level:',
            model_name: 'level_id',
            ref:        'level_id_input',
            ref_alt:    'level_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Area:',
            model_name: 'area_id',
            ref:        'area_id_input',
            ref_alt:    'area_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Room Type:',
            model_name: 'room_type_id',
            ref:        'room_type_id_input',
            ref_alt:    'room_type_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'vue-multiselect',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Supervisor:',
            model_name: 'associate_id',
            ref:        'associate_id_input',
            ref_alt:    'associate_id_input_alt',
            required:   false,
            multiple:   true
        },
        {
            css_class:  'col-md-6',
            type:       'vue-multiselect',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Associate:',
            model_name: 'employee_associate_id',
            ref:        'employee_associate_id_input',
            ref_alt:    'employee_associate_id_input_alt',
            required:   false,
            multiple:   true
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Template:',
            model_name: 'inspection_template_id',
            ref:        'inspection_template_id_input',
            ref_alt:    'inspection_template_id_input_alt',
            required:   false,
        },
    ]
}

export default FormResources;